import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.module.scss';

const block = 'dek';

function Dek({ dek, styles: propStyles }) {
  return (
    <p className={classNames(block, styles.dek, propStyles, 'f3', 'publico-txt', 'lh-copy', 'mb0')}>
      {dek}
    </p>
  );
}

Dek.propTypes = {
  dek: PropTypes.string.isRequired,
  styles: PropTypes.oneOfType([
    PropTypes.objectOf(PropTypes.object),
    PropTypes.string,
    PropTypes.array,
  ]),
};

Dek.defaultProps = {
  styles: '',
};

export default Dek;
